import React from 'react';
import Modal from 'react-modal';
import Box from 'components/Box';
import Dialog from 'components/Dialog';
import BoxBody from 'components/BoxBody';
import EventTracking from 'lib/EventTracking';
import SplitComposerDataContainer from './SplitComposerDataContainer';
import { withRouter } from 'app/context/Router';
import ConfirmDialog from 'components/ConfirmDialog';
import { ComposerContext, UIEventContext } from './ComposerContext';
import CurrentUser from 'auth/CurrentUser';

import { MessageType } from './SplitComposer';
import { bindActionCreators } from 'redux';
import { connect, Dispatch } from 'react-redux';
import { clearSelection } from 'reducers/roleBasedMessagingSearch';

type Props = {
  skipSelectRecipients: boolean;
  messageType: MessageType;
  onRequestHide: () => void;
  router: any;
  onComposerPage: boolean;
};

type State = {
  isOpen: boolean;
  // Controls whether to show the "Discard selection?" modal on cancel
  significantChange: boolean;
  // Set when the user clicks "Continue" to move to the composer,
  // so we don't treat it as a cancel action in handleRequestHide
  isContinue: boolean;
};

type ReduxDispatchProps = {
  clearSelection: () => void;
};

class SplitComposerModal extends React.Component<Props & ReduxDispatchProps, State> {
  state: State = {
    isOpen: false,
    significantChange: false,
    isContinue: false,
  };

  handleConfirm = () => {
    this.props.clearSelection();
    this.props.onRequestHide();
  };
  handleCancel = () => this.setState({ isOpen: false });

  generateHandleRequestHide = (uiEventContext: UIEventContext) => () => {
    if (!this.state.isContinue && !this.props.onComposerPage) {
      EventTracking.trackKey(`announcements.share_to.cancel.click`, uiEventContext);

      if (this.state.significantChange) {
        this.setState({ isOpen: true });
        return;
      }
    }
    this.props.onRequestHide();
  };

  handleSignificantChange = () => {
    if (!this.state.significantChange) {
      this.setState({ significantChange: true });
    }
  };

  handlePageChange = () => {
    this.setState({ isContinue: true });
    this.props.onRequestHide();
    this.props.router.push('/compose');
  };

  render() {
    return (
      <React.Fragment>
        <Modal isOpen={this.state.isOpen} data-test="confirm-close-dialog">
          <ConfirmDialog
            hideCloseButton
            cancelButtonText="Cancel"
            actionButtonText="Discard"
            onCancel={this.handleCancel}
            onConfirm={this.handleConfirm}
            onRequestHide={this.handleCancel}
            title="Discard selection?"
          />
        </Modal>
        <ComposerContext.Consumer>
          {composerContext => {
            if (!CurrentUser.isSignedIn()) {
              return null;
            }
            return (
              <Dialog
                size="large"
                className="SplitComposerModal"
                onRequestHide={this.generateHandleRequestHide(composerContext.getUIEventContext())}
                box={false /* a boxed dialog has bigger font size than a box in a dialog */}>
                <Box>
                  <BoxBody full>
                    <SplitComposerDataContainer
                      {...this.props}
                      onPageChange={
                        this.props.onComposerPage ? this.props.onRequestHide : this.handlePageChange
                      }
                      onSignificantChangeMade={this.handleSignificantChange}
                    />
                  </BoxBody>
                </Box>
              </Dialog>
            );
          }}
        </ComposerContext.Consumer>
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch<any>): any =>
  bindActionCreators({ clearSelection }, dispatch);

export { SplitComposerModal };
export default withRouter(connect(undefined, mapDispatchToProps)(SplitComposerModal));
